import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { color } from "./color";

export const EditForm = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: 40%;
  min-width: 300px;
  padding: 1.5rem;
  background-color: white;
  z-index: 10;
  position: fixed;
  top: 25%;
  left: 50%;
  transform: translate(-50%, 0%);
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  &:before {
    content: "修改";
    display: inline-flex;
    align-items: center;
    padding: 0 1rem;
    color: white;
    width: 100%;
    background-color: ${color.markedSecondary};
    position: absolute;
    top: -30%;
    left: 0;
    height: 30%;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  @media (min-width: 768px) {
    max-width: 400px;
    padding: 2rem;
  }
  label {
    border-bottom: 1px solid rgba(119, 113, 128, 0.5);
    margin-bottom: 1rem;
    color: ${color.default};
    input {
      margin-left: 0.5rem;
      border: none;
      &:focus-visible {
        outline: none;
      }
    }
  }
  .btnGroup {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    justify-content: flex-end;
  }
  .btn {
    background-color: ${color.markedSecondary};
    color: white;
    border: none;
    border-radius: 0.2rem;
    margin: 0 0.5rem;
    padding: 0.2rem 0.5rem;
    cursor: pointer;
  }
  .cancel {
    background-color: white;
    color: ${color.markedSecondary};
  }
`;
export const Mask = styled.div`
  width: 100vw;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0;
  ${(props: { editable: boolean }) =>
    props.editable &&
    css`
      opacity: 1;
    `}
`;
export const FunctionBar = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
  margin-bottom: 1rem;
  position: relative;
  @media (min-width: 768px) {
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  @media print {
    display: none;
  }
  .mask {
    display: ${(props: { mutipleShow: boolean; show: boolean }) =>
      props.mutipleShow ? "inline-block" : "none"};
    position: fixed;
    background-color: black;
    opacity: 0.5;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 50;
  }
  .box {
    display: flex;
    align-items: flex-start;
    flex-flow: ${(props: { show: boolean; mutipleShow: boolean }) =>
      props.show ? "column wrap" : "row wrap"};
    order: 2;
    @media (min-width: 768px) {
      order: 1;
    }
    .labelTag {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 1rem;
      color: ${color.default};
      border-bottom: 1px solid ${color.default};
      transition: all 0.5s;
      padding-bottom: 0.3rem;
      &:focus-within {
        color: ${color.markedSecondary};
        border-bottom: 1px solid ${color.markedSecondary};
      }
      @media (min-width: 768px) {
        margin-top: 0;
        margin-right: 1rem;
        padding-bottom: 0;
        width: auto;
        max-width: 200px;
      }
      input {
        margin-left: 0.3rem;
        border: none;
        outline: none;
        position: relative;
      }
    }
  }
  .btn {
    background-color: ${color.markedSecondary};
    color: white;
    border: 1px solid ${color.markedSecondary};
    border-radius: 0.2rem;
    padding: 0.2rem 0.5rem;
    cursor: pointer;
    margin-top: 1rem;
    margin-right: 1rem;
    @media (min-width: 768px) {
      margin-top: 0rem;
    }
    &:disabled {
      background-color: ${color.secondary};
      color: #d4d4d4;
      border: 1px solid #d4d4d4;
    }
  }
  .btnGroup {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    @media (min-width: 768px) {
      width: auto;
    }
    .btn {
      margin-right: 0;
      width: 50%;
    }
  }
  .uploadBox {
    display: ${(props) => (props.mutipleShow ? "flex" : "none")};
    flex-flow: column nowrap;
    position: fixed;
    background-color: white;
    padding: 2rem;
    width: 80%;
    z-index: 100;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    &:before {
      content: "批量新增 / 覆盖";
      padding: 0.5rem 0.8rem;
      color: white;
      background-color: ${color.markedSecondary};
      width: 100%;
      height: 2.5rem;
      border-top-right-radius: 0.5rem;
      border-top-left-radius: 0.5rem;
      position: absolute;
      top: -2.5rem;
      left: 0%;
    }
    @media (min-width: 768px) {
      width: 50%;
      max-width: 450px;
    }
    .ant-radio-checked .ant-radio-inner {
      border-color: ${color.markedSecondary};
      &:after {
        background-color: ${color.markedSecondary};
      }
    }
  }
  .uploadBtn {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    min-width: 80px;
    text-align: center;
    margin: 0;
    @media (min-width: 768px) {
      margin-bottom: 1rem;
    }
  }
  .addBtn {
    @media (min-width: 768px) {
      margin: 0;
      margin-top: 1rem;
    }
  }
  .delBtn {
    margin-left: 0;
  }
  .cancelBtn {
    background-color: white;
    color: ${color.markedSecondary};
    transition: all 0.3s;
  }
  .addInfo {
    display: ${(props) => (props.show ? "flex" : "none")};
    flex-flow: row wrap;
  }
`;
export const TableOutter = styled.div`
  .btn {
    cursor: pointer;
    color: ${color.default};
    transition: all 0.3s;
    &:hover {
      color: ${color.warnning};
    }
  }
  .ant-table-container {
    border: 0;
    border-left: 1px solid #f0f0f0;
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0 !important;
    }
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-container {
    border: 0 !important;
  }
  .ant-table-row {
    &:nth-of-type(odd) {
      //3n+4
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      //3n+4
      background-color: white;
    }
    @media print {
      page-break-inside: avoid;
    }
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
`;
